<template>
  <div class="dwp-overflow-auto">
    <template v-if="Object.keys(tasks).length">
      <Draggable ghost-class="dwp-opacity-0" v-model="ordered" handle=".dwp-drag-handle">
        <Task
          v-for="task in ordered"
          :key="task.id"
          class="dwp-bg-white"
          :task="task"
          @trash="trash(task)"
          @toggle="toggleDone(task)"
        />
      </Draggable>
      <template>
        <div
          class="dwp-py-4 dwp-mx-10 dwp-border-t dwp-border-gray-200 dwp-flex dwp-space-x-2 dwp-text-sm dwp-group"
          v-if="currentList.counts.done"
        >
          <div
            class="dwp-flex-1 dwp-text-gray-500 dwp-cursor-pointer"
            @click="showCompleted = !showCompleted"
          >
            <span>+{{ currentList.counts.done }} Done</span>
            <span
              class="dwp-opacity-0 group-hover:dwp-opacity-100 dwp-transition-opacity dwp-duration-200 dwp-inline-flex dwp-items-center dwp-px-2 dwp-py-1 dwp-rounded-full dwp-text-xs dwp-font-medium dwp-leading-4 dwp-bg-gray-100 dwp-text-gray-700"
            >{{ showCompleted ? 'Hide' : 'Show'}}</span>
          </div>
        </div>
        <template v-if="showCompleted">
          <Task
            v-for="task in doneOrdered"
            :key="task.id"
            :task="task"
            @trash="trash(task)"
            @toggle="toggleDone(task)"
            class="dwp-bg-white"
          />
        </template>
      </template>
    </template>
    <div class="dwp-flex dwp-items-center dwp-justify-center dwp-p-6" v-else-if="done.length">
      <div class="dwp-text-center dwp-text-gray-500 dwp-space-y-2">
        <svg fill="currentColor" viewBox="0 0 20 20" class="dwp-w-6 dwp-m-auto">
          <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
          <path
            fill-rule="evenodd"
            d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
            clip-rule="evenodd"
          />
        </svg>
        <div class="dwp-font-medium">
          <template v-if="done.length">All Done!</template>
        </div>
      </div>
    </div>

    <NewTask @edit="scrollBottom" />
  </div>
</template>

<script>
import Task from "./Task.vue";
import NewTask from "./NewTask.vue";
import { sync, call, get } from "vuex-pathify";
import { CheckCircleIcon } from "vue-feather-icons";
import Draggable from "vuedraggable";
import currentList from "@/mixins/current-list";
import sortBy from "lodash/sortBy";
import { Firebase } from "@/services/firebase";
let db = Firebase.firestore();

export default {
  mixins: [currentList],
  components: {
    Task,
    NewTask,
    Draggable,
    CheckCircleIcon,
  },

  computed: {
    tasks: sync("tasks/items"),
    team: get("user/user@team"),
    source: get("ui/source"),
    currentTasks() {
      return this.filterObject(this.tasks, (item) => {
        return item.list_id === this.currentList.id;
      });
    },

    ordered: {
      get() {
        if (!this.currentList) {
          return [];
        }
        let order = this?.currentList?.order || [];
        let byDate = sortBy(Object.values(this.active || {}), ["created_at"]);
        return sortBy(byDate, [
          function (o) {
            if (order.indexOf(o.id) == -1) {
              return 99999999999;
            }
            return order.indexOf(o.id);
          },
        ]);
      },

      set(list) {
        this.$store.dispatch("lists/patch", {
          id: this.currentList.id,
          ...{
            order: list.map((o) => o.id),
          },
        });
      },
    },

    active() {
      return this.filterObject(this.currentTasks, (task) => {
        return !task.done;
      });
    },

    done() {
      return this.filterObject(this.currentTasks, (task) => {
        return task.done;
      });
    },
    doneOrdered() {
      if (!this.currentList) {
        return [];
      }
      let order = this?.currentList?.order || [];
      let byDate = sortBy(Object.values(this.done || {}), ["created_at"]);
      return sortBy(byDate, [
        function (o) {
          if (order.indexOf(o.id) == -1) {
            return 99999999999;
          }
          return order.indexOf(o.id);
        },
      ]);
    },
    currentId: get("lists/currentId"),
    showCompleted: sync("ui/showCompleted"),
  },

  mounted() {
    this.list = this.currentList?.order;
    this.bindTasks();
  },

  data() {
    return {
      list: [],
      loading: false,
      completed: false,
    };
  },

  watch: {
    async showCompleted(val) {
      await this.$store.dispatch("tasks/closeDBChannel");
      await this.bindTasks();
      if (val) {
        this.$store.dispatch("lists/updateCounts", this.currentList);
      }
    },
    async currentListId() {
      await this.bindTasks();
    },
  },

  methods: {
    ...call("tasks/*"),
    scrollBottom() {
      console.log("scrollBottom");
      this.$nextTick(() => {
        setTimeout(() => {
          this.$el.scrollTop = this.$el.scrollHeight;
        }, 1);
      });
    },
    trash(task) {
      let r = confirm("Are you sure?");
      if (r) {
        this.removeTask(task);
      }
    },
  },
};
</script>